import React, { useMemo } from "react";
import SearchAutocomplete from "../UIParts/SearchAutocomplete";

import { getProductTypeMap } from "../../utils/enumFormatter";

interface ProductTypeAutocompleteFieldProps {
  value: number; // מחזיקים את המספר
  onChange: (newValue: number) => void;
  placeholder?: string;
  showIcons?: boolean;
}

export const ProductTypeAutocompleteField: React.FC<ProductTypeAutocompleteFieldProps> = ({
  value,
  onChange,
  placeholder = "בחר סוג מוצר...",
  showIcons = true,
}) => {
  const productTypeMap = useMemo(() => getProductTypeMap(), []);

  const options = useMemo(() => {
    return Object.values(productTypeMap); // שמות של סוגי מוצרים
  }, [productTypeMap]);

  const selectedLabel = useMemo(() => {
    return productTypeMap[value] || ""; 
  }, [value, productTypeMap]);

  const handleSelect = (selectedLabel: string) => {
    const code = Number(
      Object.entries(productTypeMap).find(([, label]) => label === selectedLabel)?.[0]
    );
    if (!isNaN(code)) {
      onChange(code); // מחזירים את הקוד (מספר)
    } else {
      onChange(-1); // אם לא מצאנו
    }
  };

  return (
    <SearchAutocomplete
      placeholder={placeholder}
      options={options}
      value={selectedLabel}
      onChange={handleSelect}
      showIcons={showIcons}
    />
  );
};
